import { Link } from 'react-router-dom'
import { LoginForm } from '@/components/auth/LoginForm'
import { AuthLogo } from '@/components/auth/AuthLogo'
import { LanguageSwitcher } from '@/components/common/LanguageSwitcher'
import { ROUTES } from '@/utils/constants'
import { useTranslation } from 'react-i18next'
import { Box, Card, CardContent, Typography } from '@mui/material'
import '@/styles/auth.css'

export function LoginPage() {
  const { t } = useTranslation()

  return (
    <Box className="auth-page">
      <Box className="auth-language-switcher">
        <LanguageSwitcher />
      </Box>
      <Box className="auth-container">
        <Card className="auth-card">
          <CardContent>
            <AuthLogo />

            <Typography variant="h1" component="h1" sx={{ textAlign: 'center', mb: 1 }}>
              {t('auth.loginTitle')}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mb: 3 }}>
              {t('auth.loginSubtitle')}
            </Typography>

            <LoginForm />

            <Box sx={{ textAlign: 'center', mt: 2 }}>
              <Link to={ROUTES.FORGOT_PASSWORD} className="auth-link">
                {t('auth.forgotPassword')}
              </Link>
            </Box>

            <Box className="auth-footer">
              <Typography variant="body2">
                {t('auth.noAccount')}{' '}
                <Link to={ROUTES.REGISTER} className="auth-link">
                  {t('auth.register')}
                </Link>
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  )
}
